"use client"

import AdMarker from "./AdMarker"
import AdSenseAd from "./AdSenseAd"

interface AdSlotProps {
  adSlot: string
  adFormat?: "auto" | "fluid" | "rectangle" | "vertical" | "horizontal"
  style?: React.CSSProperties
  className?: string
  // AdMarker specific props
  position?: string
  recommendedSize?: string
  notes?: string
}

export default function AdSlot({
  adSlot,
  adFormat = "auto",
  style,
  className = "",
  position,
  recommendedSize = "Responsive",
  notes,
}: AdSlotProps) {
  // Show ads when NEXT_PUBLIC_ADSENSE is set, markers otherwise
  const showMarker = !process.env.NEXT_PUBLIC_ADSENSE

  if (showMarker) {
    // Use position or adSlot as fallback for position
    const markerPosition = position || `Ad Slot: ${adSlot}`
    return <AdMarker position={markerPosition} recommendedSize={recommendedSize} notes={notes} className={className} />
  }

  // In production, show the actual AdSense ad
  return <AdSenseAd adSlot={adSlot} adFormat={adFormat} style={style} className={className} />
}
